export default __webpack_public_path__ + "static/media/create.65daf562.svg";